const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://vigorbuyspread.quest';

const siteSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Vigorbuy Spreadsheet",
    "url": SITE_URL,
    "description": "Complete Vigorbuy Spreadsheet resource hub with guides, templates, reviews, comparisons and expert tips for better data management.",
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${SITE_URL}/search?q={search_term_string}`,
      "query-input": "required name=search_term_string"
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Vigorbuy Spreadsheet",
    "url": SITE_URL,
    "description": "Your ultimate resource for Vigorbuy Spreadsheet guides, templates, comparisons and expert tips.",
    "sameAs": [
      "https://kaspreadsheet.com"
    ]
  }
];

export default function SiteSchemas() {
  return (
    <>
      {siteSchemas.map((schema, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
}